import React from 'react';
import { StarIcon } from 'lucide-react';
export function TopBar() {
  const renderStars = () => <div className="flex space-x-0.5 text-orange" data-id="element-114">
      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-2 h-2 md:w-4 md:h-4 fill-current" data-id="element-115" />)}
    </div>;
  return <div className="bg-navy-light border-b border-navy-lighter py-2 px-1 md:px-4" data-id="element-116">
      <div className="max-w-7xl mx-auto flex flex-nowrap justify-center items-center gap-x-1.5 md:gap-x-5 text-[8px] md:text-xs text-gray-300" data-id="element-117">
        <div className="flex items-center gap-0.5 md:space-x-1 whitespace-nowrap" data-id="element-118">
          <span className="font-semibold text-white" data-id="element-119">Facebook</span>
          {renderStars()}
          <span data-id="element-120">1,600+</span>
        </div>
        <div className="w-px h-3 bg-navy-lighter shrink-0" data-id="element-121"></div>
        <div className="flex items-center gap-0.5 md:space-x-1 whitespace-nowrap" data-id="element-122">
          <span className="font-semibold text-white" data-id="element-123">Google</span>
          {renderStars()}
          <span data-id="element-124">480+</span>
        </div>
        <div className="w-px h-3 bg-navy-lighter shrink-0" data-id="element-125"></div>
        <div className="flex items-center gap-0.5 md:space-x-1 whitespace-nowrap" data-id="element-126">
          <span className="font-semibold text-white" data-id="element-127">Yelp</span>
          {renderStars()}
          <span data-id="element-128">850+</span>
        </div>
      </div>
    </div>;
}